var $ = jQuery;

//opens all external links in new tabs
function fullTwitter() {
  // if($('.full-twitter').length) {
  $('a').each(function() {
    var cleanedHost;

    if(location.host.indexOf('www.') === 0) {
      cleanedHost = window.location.host.replace('www.','');
    }
    else {
      cleanedHost = window.location.host;
    }

    var a = new RegExp(cleanedHost);

    if(!a.test($(this).prop('host'))) {
      $(this).click(function(event) {
        event.preventDefault();
        event.stopPropagation();
        window.open(this.href, '_blank');
      }).attr('data-external', 'yes');
    }
  });
  // }
}

export { fullTwitter };

